import { render } from "./LayoutVariantTwo.vue?vue&type=template&id=a58d155c&scoped=true"
import script from "./LayoutVariantTwo.vue?vue&type=script&lang=js"
export * from "./LayoutVariantTwo.vue?vue&type=script&lang=js"

import "./LayoutVariantTwo.vue?vue&type=style&index=0&id=a58d155c&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a58d155c"]])

export default __exports__